<template>
	<div class="px-6 py-4 mt-6 rounded-lg bg-amber-900/10">
		<div class="flex gap-4">
			<div
				class="flex items-center justify-center flex-shrink-0 w-12 h-12 rounded-full bg-amber-900/10"
			>
				<Icon
					:icon="['far', 'question-circle']"
					class="w-5 h-5 text-amber-900"
				/>
			</div>

			<div class="flex-1 min-w-0">
				<div class="flex flex-col gap-0.5">
					<h4 class="mb-0 text-lg font-medium text-neutral-800">
						{{ $t(copy.heading) }}
					</h4>
					<p class="mb-0 text-sm leading-normal text-neutral-600">
						{{ $t(copy.subheading) }}
					</p>
				</div>

				<div class="grid grid-cols-1 mt-6 mb-6">
					<div>
						<h5 class="mb-2 text-base font-normal text-neutral-800">
							{{ $t(copy.firstColumnHeading) }}
						</h5>
						<ul
							class="mb-0 text-sm leading-relaxed list-disc list-inside text-neutral-600"
						>
							<li
								v-for="bulletPoint in copy.bulletPoints"
								:key="bulletPoint"
							>
								{{ $t(bulletPoint) }}
							</li>
						</ul>
					</div>
				</div>

				<div
					class="flex flex-col items-start space-y-3 md:items-center md:flex-row md:space-x-3 md:space-y-0"
				>
					<nuxt-link
						v-if="canRetake && retakeQuizLink"
						:to="retakeQuizLink"
					>
						<Button type="secondary" icon="sync">
							{{
								$t(
									'personality_results.refine_search.repeat_test'
								)
							}}
						</Button>
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '~/components/ui/common/Button'
import Icon from '~/components/ui/common/Icon'

export default {
	name: 'RefineSearchApplicantCard',
	components: {
		Button,
		Icon
	},
	props: {
		copy: {
			type: Object,
			required: true
		},
		canRetake: {
			type: Boolean,
			default: false
		},
		retakeQuizLink: {
			type: Object,
			default: null
		}
	}
}
</script>
